import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, NgClass } from '@angular/common';
import { getLorenzFormLayoutEnumString, LibFormValidityDotComponent, LorenzFormComponentDisplayOptions, LorenzFormComponentOptionsDefault, LorenzFormControl, LorenzFormGroup } from '@lib/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'lib-form-control-textarea',
	imports: [CommonModule, FormsModule, ReactiveFormsModule, NgClass, LibFormValidityDotComponent, TranslateModule],
	templateUrl: './lib-form-control-textarea.component.html',
	styleUrl: './lib-form-control-textarea.component.scss'
})
export class LibFormControlTextareaComponent implements OnInit {
	@Input({ required: true, alias: 'control' }) lorenzFormControl!: LorenzFormControl;

	@Input({ required: false, alias: 'options' }) lorenzFormComponentDisplayOptions: LorenzFormComponentDisplayOptions = {};

	@Input({ required: false }) rows = 5;

	@HostBinding('attr.class') hostCssClass = '';

	lorenzFormGroup!: LorenzFormGroup;

	ngOnInit() {
		this.lorenzFormGroup = this.lorenzFormControl.parent as LorenzFormGroup;

		this.lorenzFormControl.payload.displayOptions = this.lorenzFormComponentDisplayOptions;

		// prettier-ignore
		this.hostCssClass = [
				this.lorenzFormControl.getKey(),
				getLorenzFormLayoutEnumString(this.lorenzFormComponentDisplayOptions?.layout ?? null)
			].join(' ');
	}

	get showErrorMessages(): boolean {
		return this.lorenzFormControl.showErrors() && (this.lorenzFormComponentDisplayOptions.showErrorMessages ?? LorenzFormComponentOptionsDefault.showErrorMessages);
	}
}
